export const TEST_CLIENT_KEY =
  "pk_test_51PODhQCZ2e3LaUkuAP6zOY15D5WwoMo8nZUTKd21lOIDxxHNY0TB7fOgGtMNxSQGVxLbkY4PDEz6x7yPGguh6MZb00LAlmXQVI";
// export const TEST_CLIENT_KEY =
//   "pk_test_51Mzkp7ITuIlz575ivol6fzkYduTdDKHgAudxugxaqn8N8AM1h0qcmw95rivH5HWXNeyToz5kEzdcC4ntnPss05yF00bpwqr8mC";
